exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-automation-node-sequence-label{display:flex;align-items:center}.fts-automation-node-sequence-label .automation-node-sequence-label__label:not(:first-child){margin-left:.25rem}.fts-automation-node-sequence-label .automation-node-sequence-label__divider{flex-shrink:0}.fts-automation-node-sequence-label .automation-node-sequence-label__activity{min-width:0}.automation-node-sequence-label-tippy-content .fts-label-group .label-group__label{color:var(--fts-light)}", ""]);

// exports
